<div class="container">
  <div class="toaster-container">
    <c11n-banner [variant]="erroType" (closeEvent)="remove()" [headingText]="title" size="large">
      {{ message }}
    </c11n-banner>
  </div>
</div>
